<template>
  <nav class="navbar container" role="navigation" aria-label="main navigation" :style="{background: bg_color, }">
    <div class="navbar-brand">
        <strong class="is-size-3">
          <svg class="icon" @click="animateLogo()" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px"
               viewBox="0 0 550 550" style="enable-background:new 0 0 550 550;" xml:space="preserve">
<g>
	<rect x="207.87" y="207.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="28.87" y="207.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="386.88" y="207.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="207.87" y="28.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="207.87" y="386.88" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="28.87" y="386.88" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="28.87" y="28.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="297.38" y="118.37" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="386.88" y="28.87" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="297.38" y="297.38" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="386.88" y="386.88" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="118.37" y="297.38" class="st0" width="134.25" height="134.25" rx="20px"/>
  <rect x="118.37" y="118.37" class="st0" width="134.25" height="134.25" rx="20px"/>
</g>
            <g>
	<path class="st1" d="M457.71,92.29v365.42H92.29V92.29H457.71 M550.71-0.71h-93H92.29h-93v93v365.42v93h93h365.42h93v-93V92.29
		V-0.71L550.71-0.71z"/>
</g>
            <g>
	<circle class="st2" cx="275" cy="275" r="250.00"/>
              <circle class="st3" cx="275" cy="25" r="23"/>
              <circle class="st3" cx="275" cy="525" r="23"/>
              <circle class="st3" cx="525" cy="275" r="23"/>
              <circle class="st3" cx="25" cy="275" r="23"/>
</g>
</svg>

          <!--            <img class="icon" src="../../assets/evity.svg" alt="EvityLogo" width="112" height="28">&nbsp;-->
            Evity
        </strong>
      <div
        role="button"
        class="navbar-burger main-navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        @click="showNav = !showNav"
        :class="{ 'is-active': showNav }"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </div>
    </div>
    <div class="navbar-menu"
         :class="{ 'is-active': showNav }"
         >
      <div class="navbar-start">
        <router-link to="/" @click="showNav=false" class="navbar-item">{{ $t('main.home') }}</router-link>
        <router-link v-if="loggedIn" to="/application" @lcick="showNav=false" class="navbar-item">{{ $t('main.Application' )}}</router-link>
        <router-link v-if="loggedIn && groups.some(item => item.name === 'PROJECT_MANAGER')" @click="showNav=false" to="/projects" class="navbar-item">{{ $t('main.projects') }}</router-link>
        <router-link v-if="loggedIn && groups.some(item => item.name === 'COLLABORATOR')" @click="showNav=false" to="/tasks" class="navbar-item">
          <div class="container">
            <span title="Badge top right" class="badge is-top-right is-danger" v-if="open_tasks > 0">{{ open_tasks }}</span>
            {{ $t('main.Collaboration') }}
          </div>
        </router-link>
        <router-link v-if="loggedIn && groups.some(item=> item.name === 'CAMPAIGN_PARTICIPANT')" @click="showNav=false" to="/campaign/collect" class="navbar-item"> {{ $t('main.Campaigns' )}} </router-link>
        <router-link v-if="loggedIn && groups.some(item => item.name ==='NEWS_READER')" @click="showNav=false" to="/newsroom" class="navbar-item">{{ $t('main.Newsroom') }}</router-link>
        <div class="navbar-item gas-dropdown is-hoverable" v-if="loggedIn && groups.some(item => item.name === 'CONTENT_ADMIN')" >
          <a class="navbar-link">
            {{ $t('main.More') }}
          </a>
          <div class="navbar-dropdown">
            <router-link to="/kpis" @click="showNav=false" class="navbar-item">{{ $t('main.kpimanagement') }}</router-link>
            <router-link to="/templates" @click="showNav=false" class="navbar-item">{{ $t('main.templates') }}</router-link>
<!--            <router-link to="/list/assessmenttemplates" @click="showNav=false" class="navbar-item">{{ $t('main.templates' )}}</router-link>-->
            <router-link to="/survey" @click="showNav=false" class="navbar-item">{{ $t('main.Surveys') }}</router-link>
            <router-link to="/campaign" @click="showNav=false" class="navbar-item">{{ $t('main.Campaigns') }}</router-link>
            <router-link to="/forms/news/add" @click="showNav=false" class="navbar-item">{{ $t('main.New News' )}}</router-link>
            <router-link to="/forms/suggestions/add" @click="showNav=false" class="navbar-item">{{ $t('main.New Suggestion' )}}</router-link>
            <router-link to="/list/organizations" @click="showNav=false" class="navbar-item">{{ $t('main.Organizations' )}}</router-link>
            <router-link to="/list/users" @click="showNav=false" class="navbar-item">{{ $t('main.Users' )}}</router-link>
            <router-link to="/list/blogposts" @click="showNav=false" class="navbar-item">{{ $t('main.Blog' )}}</router-link>
            <router-link to="/list/news" @click="showNav=false" class="navbar-item">{{ $t('main.News' )}}</router-link>
            <router-link to="/list/notifications" @click="showNav=false" class="navbar-item">{{ $t('main.Notifications' )}}</router-link>
          </div>
        </div>
        <div class="navbar-item gas-dropdown is-hoverable" v-if="!loggedIn" >
          <a class="navbar-link">
            {{ $t('main.The Company') }}
          </a>
          <div class="navbar-dropdown">
            <router-link to="/about/team" @click="showNav=false" class="navbar-item">{{ $t('main.The Team') }}</router-link>
            <router-link to="/about/vision" @click="showNav=false" class="navbar-item">{{ $t('main.The Vision') }}</router-link>
          </div>
        </div>
        <router-link to="/about" @click="showNav=false" class="navbar-item">{{ $t('main.about') }}</router-link>
      </div>
      <div class="navbar-end" >
        <div class="navbar-item wallet" v-if="$store.getters['auth/isAuthenticated'] && $store.getters['auth/balance']">
          <img src="@/assets/currency_symbol.svg" /> {{ balance }}
        </div>
        <div class="navbar-item">
          <router-link to="/auth/userprofile">
            <UserAvatar :user="userinfo" />
          </router-link>
        </div>
        <div class="navbar-item">
          <LocaleChanger />
        </div>
        <div class="navbar-item">
          <div class="buttons">
            <router-link to="/auth/login">
              <a class="button is-dark">
                <strong v-if="loggedIn">{{ $t('main.signout') }}</strong>
                <strong v-else>{{ $t('main.signin') }}</strong>
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import LocaleChanger from './LocaleChanger.vue';
import UserAvatar from "@/components/UserAvatar.vue";
import api from '@/services/api.js';
import session from '@/services/session.js';
import store from '@/store/index.js';
import {EventStreamContentType, fetchEventSource} from "@microsoft/fetch-event-source";

class RetriableError extends Error {}
class FatalError extends Error {}

export default {
    name: 'NavBar',
    components: {
      LocaleChanger,
      UserAvatar,
    },
    data()  {
      return {
        showNav: false,
        bg_color: 0x000000,
        number_tasks: 0,
        source: null,
      };
    },
    methods: {
      animateLogo() {
         // Get all SVG elements with class "st0"
        const rects = document.querySelectorAll('.st0');

        // Set animation duration and calculate total steps
        // const duration = 2000; // 2 seconds
        const totalSteps = 200; // Adjust as needed

        // Calculate step size based on duration and total steps
        const stepSize = 25 / totalSteps; // Assuming the final radius is 25

        // Set initial radius
        let currentRadius = 0;

        // Define the animation function
        function animate() {
            // Update the radius for each SVG element
            rects.forEach(rect => {
                // Apply the new radius to the SVG element
                rect.setAttribute('rx', currentRadius);
                rect.setAttribute('ry', currentRadius);
            });

            // Increment the radius for the next step
            currentRadius += stepSize;

            // Check if the animation should continue
            if (currentRadius <= 25 && currentRadius <= totalSteps) {
                // Request the next animation frame
                requestAnimationFrame(animate);
            }
        }

        // Start the animation
        animate();
      },
      // get_tasks() {
      //   setTimeout(async () => {
      //     console.log('timeouting get_tasks' );
      //     if (this.loggedIn) {
      //       const rv = await api.projectkpitasks.fetch({owner: this.userinfo.pk, completed: false});
      //       console.log("ProjectKpiTaks is", rv)
      //       this.number_tasks = rv.count;
      //     }
      //
      //   }, 1000)
      // },
    },
    computed: {
      open_tasks() {
        return this.$store.getters['auth/tasks'];
      },
      loggedIn() {
        // console.log("Checking if logged in:", this.$store.getters['auth/isAuthenticated']);
        return this.$store.getters['auth/isAuthenticated'];
      },
      username() {
        const userinfo = this.$store.getters['auth/getUserInfo'];
        if (userinfo) {
          return userinfo.username;
        } else {
          return '';
        }
      },
      userinfo() {
        const ui = this.$store.getters['auth/getUserInfo'];
        if (ui) {
          return ui;
        } else {
          return null;
        }
      },
      groups() {
        const ui = this.$store.getters['auth/getUserInfo'];
        console.log("UserInfo:", ui)
        if (ui) {
          console.log("Check for xx", ui.group_details.some(item => item.name === 'PROJECT_MANAGER'))
          return ui.group_details;
        } else {
          return [];
        }
      },
      balance() {
        return this.$store.getters['auth/balance'];
      },
    },
    mounted() {
      this.bg_color = process.env.VUE_APP_BACKGROUND;
      this.animateLogo();
      // this.get_tasks();
    },
    watch: {
      async 'userinfo'() {
        console.log("Watcher auf userinfo");
/*        if (this.loggedIn) {
          console.log("Now I'm logged in. I can maybe now start the stream with a session?")
          // try to connect to stream
          if (typeof (EventSource) !== 'undefined') {
            this.source = new EventSource(process.env.VUE_APP_STREAM_BASE_URL, { withCredentials: true});
            this.source.onerror = function () {
              console.log("Connection to serverside events could not be established.")
            }
            this.source.onmessage = function (event) {
              if (event.data) {
                console.log(event.data);
                const payload = JSON.parse(event.data);
                // this.process_payload(payload)
              }
            }

          } else {
            console.log('Your browser does not support server-sent events.');
          }
        } else {
          this.source.close();
        }*/
/*        if (this.loggedIn) {
          const response = await session.get(process.env.VUE_APP_STREAM_BASE_URL, {
            method: 'GET',
            headers: {
              'Content-Type': 'text/event-stream'
            },
            body: {
              'nothing': 'important'
            }
          })
          console.log("Response:", response)
          const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
          while (true) {
            const {value, done} = await reader.read();
            if (done) break;
            console.log('Received:', value)
          }
        }*/
        if (this.loggedIn) {
          const token = this.$store.getters['auth/token']
          // console.log("User Info:", token)
/*          try {
            await fetchEventSource(process.env.VUE_APP_STREAM_BASE_URL, {
              headers: {
                'Authorization': 'Token ' + token,
              },
              async onopen(response) {
                if (response.ok && response.headers.get('content-type') === EventStreamContentType) {
                  // return; <- Optimizer told me this is not necessary
                } else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
                  throw new FatalError();
                } else {
                  throw new RetriableError();
                }
              },
              onmessage(ev) {
                console.log(ev.data);
                const payload = JSON.parse(ev.data);
                console.log("Payload:", payload, "type:", payload.type)
                if (payload['type'] !== 'struct') {
                  store.commit("toast/addToast", {
                    title: 'Backend',
                    type: payload.type,
                    message: payload.payload,
                  })
                }

              },
              onclose() {
                throw new RetriableError();
              },
              onerror(err) {
                if (err instanceof FatalError) {
                  throw err;
                } else {
                  // do nothing to automatically retry
                }
              }
            })
          } catch (err) {
            null;

          }*/


        }
        // this.get_tasks();
      }

    },
  };
</script>
<style lang="scss" scoped>
  nav {
    margin-top: 25px;
    margin-bottom: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #d88d00;
      }
    }
  }
  .st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}
  .st1{fill:#FFFFFF;}
  .st2{fill:none;stroke:#020203;stroke-width:6;stroke-miterlimit:10;}
  .st3{fill:#FFFFFF;stroke:#020203;stroke-width:6;stroke-miterlimit:10;}



  .navbar-dropdown {
    z-index: auto;
  }
</style>